import { KEYCODES, CLASSES } from "@/scripts/helpers/constants";
import UslfSearch from "@/modules/components/uslf-search";

import { trackResponse } from "@/scripts/helpers/tracking";

export const usliSearchHeader = new UslfSearch("#searchForm");

const selectMask = $(".js-search-select-mask");
const userInfoAction = $(".js-user-info-combobox");
const mobileSearchAction = $(
  ".header-navbar__item--search .header-navbar__item-action"
);
const tabletSearchAction = $(".js-search-tablet-action");

export const handleTrackMyAccount = () => {
  $(".user-info__options-list-link").on("click", function() {
    trackResponse({
      name: $(this).attr("data-name")
    });
  });
};

export const handleUserInfoAction = () => {
  userInfoAction.on("click", function() {
    mobileSearchAction.removeClass("is-active");
    $(this).toggleClass("is-open");
  });

  userInfoAction.on("keypress", function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.keyCode === KEYCODES.SPACE || e.keyCode === KEYCODES.ENTER) {
      mobileSearchAction.removeClass("is-active");
      $(this).toggleClass("is-open");
    }
  });
};

export const handleTabletSearch = () => {
  tabletSearchAction.on("click", function() {
    $(".header__nav").toggle();
    $(this).toggleClass(CLASSES.ACTIVE);
  });
};

export const handleComboboxClose = () => {
  $(document).on("click", function(event) {
    if (!$(event.target).closest(userInfoAction).length) {
      userInfoAction.removeClass("is-open");
    }

    if (!$(event.target).closest(selectMask).length) {
      selectMask.removeClass(CLASSES.ACTIVE);
    }
  });
};
